import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Content from '../../../layout/content/Content';
import Head from '../../../layout/head/Head';
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Button, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent } from '../../../components/Component';
import { Link } from 'react-router-dom';
import * as app_consts from "../../../utils/app_consts";
import AuthTenantLoader from '../../loaders/AuthTenantLoader';
import AuthTenantPageError from '../../error/AuthTenantPageError';
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import { fail_retrieve_tenant_agencies, loading_retrieve_tenant_agencies, reset_retrieve_tenant_agencies, success_retrieve_tenant_agencies } from '../../../reducers/auth_tenant/retrieve_tenant_agencies_Slice';
import { RETRIEVE_TENANT_AGENCIES_API } from '../../../api/api_data';
import { RETRIEVE_TENANT_AGENCIES_ERROR_MSG, RETRIEVE_TENANT_AGENCIES_SUCCESS_MSG } from '../../../utils/error_success_messages';
import { messageToast } from '../../../utils/Utils';
import { useSelector } from 'react-redux';
import AuthTenantNoData from '../../error/AuthTenantNoData';
import AddAgencyModal from '../../../components/modal/AddAgencyModal';
import moment from 'moment';
import { Badge } from 'reactstrap';

const AgenciesManagement = ({ tenant_info, user_info }) => {

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [page_data, setPageData] = useState([]);
  const [current_page_data, setCurrentPageData] = useState([]);
  const dispatch = useDispatch();
  const [sm, updateSm] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [add_agency_modal, setAddAgencyModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(10);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  useEffect(() => {
    retrieve_agencies();
  }, []);

  const retrieve_agencies = () => {
    dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_agencies, success_retrieve_tenant_agencies, fail_retrieve_tenant_agencies, RETRIEVE_TENANT_AGENCIES_ERROR_MSG, RETRIEVE_TENANT_AGENCIES_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_AGENCIES_API}`));
  };

  // Listener
  const retrieve_tenant_agencies_listener = useSelector((state) => state.retrieve_tenant_agencies.retrieve_tenant_agencies);

  useEffect(() => {
    if (retrieve_tenant_agencies_listener.status !== app_consts.IDLE)
    {
      if (retrieve_tenant_agencies_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_tenant_agencies_listener.status === app_consts.FAIL)
        {
          setLoading(false);
          setError(retrieve_tenant_agencies_listener.message);
          messageToast(retrieve_tenant_agencies_listener.message, app_consts.FAIL);
        } else if (retrieve_tenant_agencies_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_tenant_agencies_listener.data);
          setCurrentPageData(retrieve_tenant_agencies_listener.data);
          const timer = setTimeout(() => {
            setLoading(false);
          }, 1000);

          return () => clearTimeout(timer); // cleanup in case the component unmounts
        }
        dispatch(reset_retrieve_tenant_agencies());
      }
    }
  }, [retrieve_tenant_agencies_listener]);

  const open_add_agency_modal = () => {
    setAddAgencyModal(true);
  };

  const close_add_agency_modal = () => {
    setAddAgencyModal(false);
  };

  const successAddAgencyFunction = () => {
    close_add_agency_modal();
  };

  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = current_page_data?.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <>
      <Head title={tenant_info?.name ? `${tenant_info.name} Agencies` : "Agencies"} />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Agencies</BlockTitle>
              <BlockDes className="text-soft">
                <p>{!(loading || error) && `Agencies ${current_page_data?.length}`}</p>
              </BlockDes>
              {!(loading) && (
                <div className="mt-2">
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      retrieve_agencies();
                    }}
                  >
                    <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
                      <span>Refresh List</span>
                    </Button>
                  </Link>
                </div>
              )}
            </BlockHeadContent>
            {
              !(loading || error) && (
                <>
                  <BlockHeadContent>
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <a
                        href="#more"
                        className="btn btn-icon btn-trigger toggle-expand me-n1"
                        onClick={(ev) => {
                          ev.preventDefault();
                          updateSm(!sm);
                        }}
                      >
                        <Icon name="more-v"></Icon>
                      </a>
                      <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                        <ul className="nk-block-tools g-3">
                          <li>
                            <div className="form-control-wrap">
                              <div className="form-icon form-icon-right">
                                <Icon name="search"></Icon>
                              </div>
                              <input
                                type="text"
                                className="form-control"
                                id="default-04"
                                value={searchTerm}
                                onChange={e => setSearchTerm(e.target.value)}
                                placeholder="Search for Agency"
                              />
                            </div>
                          </li>
                          {
                            (user_info?.roles?.includes(app_consts.ADD_AGENCY) || user_info?.roles?.includes(app_consts.ADMINISTRATOR)) && (
                              <>
                                <li className="nk-block-tools-opt">
                                  <Button
                                    className="toggle btn-icon d-md-none"
                                    color="primary"
                                    onClick={() => {
                                      open_add_agency_modal();
                                    }}
                                  >
                                    <Icon name="plus"></Icon>
                                  </Button>
                                  <Button
                                    className="toggle d-none d-md-inline-flex"
                                    color="primary"
                                    onClick={() => {
                                      open_add_agency_modal();
                                    }}
                                  >
                                    <Icon name="plus"></Icon>
                                    <span>Add Agency</span>
                                  </Button>
                                </li>
                              </>
                            )
                          }
                        </ul>
                      </div>
                    </div>
                  </BlockHeadContent>
                </>
              )
            }
          </BlockBetween>
        </BlockHead>
        {
          loading ?
            <>
              <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Agencies..." />
            </>
            :
            <>
              {
                error ?
                  <>
                    <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
                  </>
                  :
                  <>
                    {
                      page_data && page_data?.length > 0 ?
                        <>
                          <Block>
                            <div className="nk-tb-list is-separate is-medium mb-3">
                              <DataTableHead className="nk-tb-item">
                                <DataTableRow>
                                  <span className="sub-text">Name</span>
                                </DataTableRow>
                                <DataTableRow size="mb">
                                  <span className="sub-text">Mobile Number</span>
                                </DataTableRow>
                                <DataTableRow size="md">
                                  <span className="sub-text">Email Address</span>
                                </DataTableRow>
                                <DataTableRow size="lg">
                                  <span className="sub-text">No. Sale Reps</span>
                                </DataTableRow>
                                <DataTableRow size="lg">
                                  <span className="sub-text">Status</span>
                                </DataTableRow>
                                <DataTableRow size="md">
                                  <span className="sub-text">Action</span>
                                </DataTableRow>
                              </DataTableHead>
                              {/*Head*/}
                              {currentItems.length > 0
                                ? currentItems.map((item) => (
                                  <DataTableItem key={item.id}>
                                    <DataTableRow>
                                      <Link to={`/${tenant_info.url_prefix}/agencies/${item?.id}`}>
                                        <div className="user-card">
                                          <div className="user-info">
                                            <span className="tb-lead">
                                              {item?.name ? item?.name : "--"}<span className="dot dot-success d-md-none ms-1"></span>
                                            </span>
                                          </div>
                                        </div>
                                      </Link>
                                    </DataTableRow>
                                    <DataTableRow>
                                      <span>{item?.mobile_number || "--"}</span>
                                    </DataTableRow>
                                    <DataTableRow>
                                      <span>{item?.email_address || "--"}</span>
                                    </DataTableRow>
                                    <DataTableRow>
                                      <span>{item?.no_sales_rep || "0"}</span>
                                    </DataTableRow>
                                    <DataTableRow size="md">
                                      <span className="tb-odr-status">
                                        <Badge
                                          color={
                                            item?.status === app_consts.ACTIVE
                                              ? "success"
                                              : "danger"
                                          }
                                          className="badge-dot"
                                        >
                                          {item?.status?.toUpperCase() || "--"}
                                        </Badge>
                                      </span>
                                    </DataTableRow>
                                    <DataTableRow className="nk-tb-col-tools">
                                      <div className="tb-odr-btns d-none d-sm-inline">
                                        <Link to={`/${tenant_info.url_prefix}/agencies/${item?.id}`}>
                                          <Button color="primary" size="sm" className="btn btn-dim">
                                            View
                                          </Button>
                                        </Link>
                                      </div>
                                      <Button className="btn-pd-auto d-sm-none">
                                        <Icon name="chevron-right"></Icon>
                                      </Button>
                                    </DataTableRow>
                                  </DataTableItem>
                                ))
                                : null}
                            </div>
                            {currentItems?.length > 0 && (
                              <div className="mt-3">
                                <PaginationComponent
                                  itemPerPage={itemPerPage}
                                  totalItems={current_page_data?.length}
                                  paginate={paginate}
                                  currentPage={currentPage}
                                />
                              </div>
                            )}
                          </Block>

                        </>
                        :
                        <>
                          <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Agencies Found"} />
                        </>
                    }
                    <AddAgencyModal isOpen={add_agency_modal} successFunction={successAddAgencyFunction} closeModal={close_add_agency_modal} tenant_info={tenant_info} user_info={user_info} />
                  </>
              }
            </>
        }
      </Content>
    </>
  );
};

export default AgenciesManagement;